/** Shared subscription + user helpers from `commonUtils.mjs`; frontend imports only via this file. Backend uses `customUtils`. */
import React from "react";import {
    MdAccessTime,
    MdOutlineNotificationsActive,
    MdOutlineEmail,
    MdOutlineSms,
    MdOutlineAltRoute,
    MdOutlineLabel
} from 'react-icons/md';

import {
    BsBoxArrowInRight,
    BsBoxArrowRight,
    BsChatSquareText,
    BsWhatsapp
} from 'react-icons/bs';

import { toast } from "react-toastify";
import commonUtils from "./commonUtils.mjs";

export const {
  generateRandomString,
  userDataToStorageString,
  SUBSCRIPTION_STATUS_OPTIONS,
  subscriptionStatusCodes,
  getSubscriptionDisplayStatus,
  API_KEY_STATUS,
  getApiKeyDisplayStatus,
  PARTNER_TYPE,
  PARTNER_CREDENTIAL_FIELD_TYPE,
  PARTNER_HTTP_METHOD,
  PARTNER_SETTING_KEY,
  PARTNER_USERS_FROM,
  PARTNER_IN_APP_WINDOW_UNIT,
  PARTNER_INCLUDE_VALUES,
  getPartnerTypeLabel,
  getPartnerUsersFromLabel,
  missingRequiredPartnerConfigFields,
  SENT_MESSAGE_DELIVERY_STATUS,
  SCHEDULED_MESSAGE_STATUS,
  WHATSAPP_MESSAGE_STATUS,
  WHATSAPP_CAMPAIGN_STATUS,
  MESSAGE_CREATED_BY_OPTIONS,
  MESSAGE_AUDIENCE_OPTIONS,
  MESSAGE_SEND_KIND_OPTIONS,
  EVENT_METRIC_OPTION,
  SUPPORT_FIELD_TYPE_OPTIONS,
  DEFAULT_STATUS,
  getStatusDisplay,
  APP_STAFF_STATUS,
  getStaffStatusDisplay,
  APP_SUPPORT_CONVERSATION_STATUS,
  APP_SUPPORT_CONVERSATION_SOURCE,
  APP_SUPPORT_RECORD_ORIGIN,
  APP_SUPPORT_MESSAGE_SENDER_TYPE,
  APP_SUPPORT_MESSAGE_SOURCE_CHANNEL,
  normalizeAppSupportConversationStatus,
  isAppSupportConversationClosed,
  getAppSupportConversationStatusDisplay,
  normalizeAppSupportConversationSource,
  getAppSupportConversationSourceDisplay,
  normalizeAppSupportRecordOrigin,
  getAppSupportRecordOriginDisplay,
  normalizeAppSupportMessageSenderType,
  getAppSupportMessageSenderDisplay,
  normalizeAppSupportMessageSourceChannel,
  findOptionByValue,
  getPlanDisplayName,
  billingStatusLabel,
  getBillingStatusDisplay,
  getInvoiceStatusDisplay,
  getInvoiceKindDisplay,
  parseInvoiceBreakdown,
  isCheckoutInvoice,
  isCheckoutInvoiceBreakdown,
  getInvoiceMetricRows,
  buildInvoiceChargeLineRows,
  resolveInvoiceTaxSnapshot,
  getPlanChangeRequestStatusDisplay,
  PLAN_CHANGE_REQUEST_STATUS_CODES,
  slugify,
  METRIC_TYPE_CODES,
  PLAN_TYPE_CODES,
  BILLING_CURRENCY_CODES,
  DEFAULT_BILLING_CURRENCY,
  bigAmountFormat,
  formatMetricPrice,
  calculateGrowthPlanEstimate,
  resolveGrowthCheckoutAmount,
  ANNUAL_BILLING_DISCOUNT_FACTOR,
  BILLING_STATUS_CODES,
  isBillingStatus,
  getCurrentBillingStatusValues,
  INVOICE_STATUS_CODES,
  INVOICE_KIND_CODES,
  PAYMENT_MODE_CODES,
  SUPPORT_TICKET_FILE_TYPES,
  SUPPORT_TICKET_ALLOWED_FILE_TYPES,
  buildSupportTicketFileAcceptAttribute,
  isSupportTicketFileAllowed,
  APP_SUPPORT_UPLOADS_PATH,
  uploadsPathToFilesystemRelative,
  buildUploadRelativeUrl,
  normalizeFileName,
  getFileExtension,
  isImageExt,
  isPdfExt,
  inferMimeFromLabel,
  resolveFileKind,
  buildUploadAbsoluteUrl,
  extractFilesFromText,
  safeJsonParse,
  normalizeSupportFieldNameKey,
  getSupportContextScalar,
  ONELINK_MODAL_STEP,
  ONELINK_TEMPLATE,
  ONELINK_CAMPAIGN_TYPE,
  ONELINK_MEDIA_SOURCE,
  ONELINK_LINK_STATUS,
  ONELINK_LINK_STATUS_ACTIVE,
  ONELINK_SOCIAL_PREVIEW,
  ONELINK_REDIRECT_TYPE,
  ONELINK_DEFAULTS,
  onelinkNormalizeOptionValue,
  getCampaignTypeLabel,
  getMediaSourceLabel,
  getOnelinkTemplateEntry,
  getOnelinkSocialPreviewEntry,
  getOnelinkRedirectLabel,
  getLinkStatusDisplay,
  buildDefaultLinkName,
  parseCustomParams,
  DEFAULT_STATUS_OPTIONS,
  formatPersonDisplayName,
  getAvatarInitials,
  NS_AVATAR_COLORS,
  nsAvatarColor,
  WHATSAPP_USAGE_TYPE_CODES,
  WA_TEMPLATE_STATUS_FILTER_OPTIONS,
  WA_TEMPLATE_CATEGORY_FILTER_OPTIONS,
  WA_TEMPLATE_BUTTON_TYPES,
  WA_AUTH_OTP_DEFAULTS,
  getWhatsAppTemplateStatusDisplay,
  getWhatsAppQualityDisplay,
  getWhatsAppTemplateCategoryDisplay,
  waMeUrl,
  formatWhatsAppMarkdownHtml,
  ROLE_TYPES,
  PERMISSION_SCOPES,
  TEAM_MEMBER_ROLE_SLUG,
  isStaffUser,
  roleHasUnrestrictedAccess,
  can: canAbility,
  canAny: canAnyAbility,
  canAll: canAllAbility,
  SUPERADMIN_PERMISSIONS,
  ADMIN_PERMISSIONS,
  groupAdminPermissionsForUi,
  SYSTEM_ROLES,
  getSystemRoleSlugs,
  getCustomerSupportPermissionKeys,
  DASHBOARD_SECTIONS,
  isDashboardSectionEnabled,
  getEnabledDashboardSectionIds,
  plainSupportTextToHtml,
  buildCsvReport,
  formatDate,
  formatTime,
  formatDateTime,
  labelizeKey,
  FUNNEL_STEP_SEPARATOR,
  FUNNEL_MIN_STEPS,
  FUNNEL_MAX_STEPS,
  FUNNEL_USERS_PAGE_SIZE,
  FUNNEL_USERS_PAGE_MAX,
  FUNNEL_SEGMENT_USER_CAP,
  FUNNEL_SEGMENT_RULE_ID,
  FUNNEL_BREAKDOWN_MAX_GROUPS,
  FUNNEL_BREAKDOWN_OPTIONS,
  FUNNEL_MODE_CODES,
  FUNNEL_SOURCE_OPTIONS,
  FUNNEL_WINDOW_OPTIONS,
  FUNNEL_FILTER_KEYS,
  FUNNEL_EVENT_COLORS,
  formatRelativeDate,
  DEFAULT_DISPLAY_LOCALE,
  toDisplayDate,
  AUTOMATION_STATUS_CODES,
  AUTOMATION_TEMPLATE_CODES,
  AUTOMATION_ENTRY_TYPE_CODES,
  AUTOMATION_EXIT_TYPE_CODES,
  AUTOMATION_EXIT_CONDITION_BITS,
  AUTOMATION_REENTRY_TYPE_CODES,
  AUTOMATION_GOAL_METRIC_CODES,
  AUTOMATION_MESSAGE_GOAL_METRIC_GROUPS,
  AUTOMATION_SCHEDULE_START_CODES,
  AUTOMATION_SCHEDULE_END_CODES,
  AUTOMATION_NODE_TYPE_CODES: COMMON_AUTOMATION_NODE_TYPE_CODES,
  AUTOMATION_ENROLL_STATUS_CODES,
  AUTOMATION_EXIT_REASON_CODES,
  AUTOMATION_WAIT_UNIT_CODES,
  getAutomationNodeType,
  serializeAutomationGraph,
} = commonUtils;

export const AUTOMATION_NODE_TYPE_CODES = Object.freeze(
    COMMON_AUTOMATION_NODE_TYPE_CODES.map(item => {
        if (item.key === 'entrance') {
            return { ...item, icon: BsBoxArrowInRight };
        }

        if (item.key === 'wait') {
            return { ...item, icon: MdAccessTime };
        }

        if (item.key === 'condition') {
            return { ...item, icon: MdOutlineAltRoute };
        }

        if (item.key === 'exit') {
            return { ...item, icon: BsBoxArrowRight };
        }

        if (item.key === 'push') {
            return { ...item, icon: MdOutlineNotificationsActive };
        }

        if (item.key === 'email') {
            return { ...item, icon: MdOutlineEmail };
        }

        if (item.key === 'in_app') {
            return { ...item, icon: BsChatSquareText };
        }

        if (item.key === 'sms') {
            return { ...item, icon: MdOutlineSms };
        }

        if (item.key === 'whatsapp') {
            return { ...item, icon: BsWhatsapp };
        }

        if (item.key === 'tag') {
            return { ...item, icon: MdOutlineLabel };
        }

        return item;
    })
);


/** POST a list endpoint with `export: 1` and download the CSV (same as User Records). */
export async function exportListCsv(path, body, filename) {
  const response = await fetchWithAuth(Utils.baseurl + path, {
    method: "POST",
    body: JSON.stringify({ ...body, export: 1 }),
  });
  const contentType = response.headers.get("content-type") || "";
  let status = false;
  let message = "Export failed";
  if (contentType.includes("text/csv")) {
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    status = true;
    message = "";
  } else {
    try {
      const result = await response.json();
      if (result?.data?.empty) {
        status = true;
        message = "No records to export for the applied filters.";
      } else {
        message = result.message || "Export failed";
      }
    } catch {
      message = "Export failed";
    }
  }
  return { status, message };
}

/**
 * API base URL, `localStorage` key names, and UI defaults only (no functions).
 */
export const Utils = {
  baseurl: process.env.REACT_APP_BASE_URL,
  storageKeys: Object.freeze({
    adminToken: "adminToken",
    adminData: "adminData",
    token: "token",
    refreshToken: "refreshToken",
    userData: "userData",
    onboard: "onboard",
    activeApp: "activeApp",
    currentSidebar: "currentSidebar",
    thirdSidebar: "thirdSidebar",
    application: "application",
    authTokenLegacy: "authToken",
  }),
  pagination: {
    defaultPageSize: process.env.REACT_APP_DEFAULT_PAGE_SIZE || 25,
  },
};

export function setLocalStorage(key, value) {
  if (typeof window === "undefined") return;
  localStorage.setItem(key, value);
}

export function getLocalStorage(key) {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(key);
}

/** Current dashboard user from localStorage (role_type + permissions). */
export function getAuthUser() {
  try {
    return JSON.parse(getLocalStorage(Utils.storageKeys.userData) || "null");
  } catch {
    return null;
  }
}

/** Logged-in account billing currency from `user.sub.currency` (already on getbyid). */
export function getAuthUserCurrency() {
  const raw = getAuthUser()?.sub?.currency;
  if (raw != null && raw !== "") return raw;
  return DEFAULT_BILLING_CURRENCY.value;
}

/**
 * Laravel-style: `can('team.view')` — checks logged-in user's permissions.
 * Account admin (`role_type=admin`) has unrestricted access.
 */
/**
 * Compose a event_metric display label without duplicating a word the base label already contains —
 * e.g. base "Revenue" + suffix "Revenue" stays "Revenue", not "Revenue Revenue". Used for the
 * app's configurable event_metric name (never hardcode "Booking"/"Revenue" text alongside it).
 */
export function composeEventMetricLabel(base, suffix) {
  const b = String(base || "").trim();
  const suf = String(suffix || "").trim();
  if (!suf) return b;
  if (b.toLowerCase().includes(suf.toLowerCase())) return b;
  return `${b} ${suf}`;
}

export function can(permission) {
  return canAbility(getAuthUser(), permission);
}

export function canAny(permissions) {
  return canAnyAbility(getAuthUser(), permissions);
}

export function canAll(permissions) {
  return canAllAbility(getAuthUser(), permissions);
}

export function removeLocalStorage(key) {
  if (typeof window === "undefined") return;
  localStorage.removeItem(key);
}

export function setAuthToken(token) {
  if (typeof window === "undefined") return;
  setLocalStorage(Utils.storageKeys.token, token);
}

export function getAuthToken() {
  if (typeof window === "undefined") return null;
  return getLocalStorage(Utils.storageKeys.token);
}

export function removeAuthToken() {
  if (typeof window === "undefined") return;
  removeLocalStorage(Utils.storageKeys.token);
  removeLocalStorage(Utils.storageKeys.refreshToken);
  removeLocalStorage(Utils.storageKeys.authTokenLegacy);
}

export function setRefreshToken(refreshToken) {
  if (typeof window === "undefined" || !refreshToken) return;
  setLocalStorage(Utils.storageKeys.refreshToken, refreshToken);
}

export function getRefreshToken() {
  if (typeof window === "undefined") return null;
  return getLocalStorage(Utils.storageKeys.refreshToken);
}

export function removeRefreshToken() {
  if (typeof window === "undefined") return;
  removeLocalStorage(Utils.storageKeys.refreshToken);
}

export function isAdminAppPath() {
  if (typeof window === "undefined") return false;
  return (window.location.pathname || "").startsWith("/admin");
}

/** Routes user may stay on when plan/billing access is blocked (pay or upgrade). */
const BILLING_RECOVERY_PATH_PREFIXES = ["/plan", "/billing", "/apps", "/roles", "/staff", "/ssl-domain-check"];

export function isBillingRecoveryPath(pathname) {
  const path =
    pathname != null
      ? String(pathname)
      : typeof window !== "undefined"
        ? window.location.pathname || ""
        : "";
  return BILLING_RECOVERY_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function getSessionExpiredLoginUrl() {
  return isAdminAppPath() ? "/admin/login" : "/signIn";
}

/**
 * True only for notifySphere auth middleware failures (verifyToken / verifyAdminToken).
 * Never treat third-party or business API errors (Meta WhatsApp, status:false envelopes, etc.) as logout.
 *
 * Our shapes:
 * - 401 `{ expired, message: "Token expired" }`
 * - 401 `{ message: "Invalid token" }`
 * - 403 `{ message: "No token provided!" }`
 */
export function isOurDashboardAuthFailure(status, body) {
  if (status !== 401 && status !== 403) return false;
  if (body == null || typeof body !== "object" || Array.isArray(body)) return false;

  // API / third-party payloads — keep the user logged in
  if (
    Object.prototype.hasOwnProperty.call(body, "status") ||
    body.error != null ||
    body.hint != null ||
    body.code != null ||
    body.data != null
  ) {
    return false;
  }

  if (body.expired) return status === 401;

  const msg = body.message != null ? String(body.message).trim() : "";
  if (status === 403 && /^no token provided!?$/i.test(msg)) return true;
  if (status === 401 && /^(invalid token|token expired)$/i.test(msg)) return true;
  return false;
}

/**
 * API ne session reject kiya ho to sahi storage clear karke login pe bhejo.
 * fetch ke baad JSON parse ke baad call karo; true = generic error toast mat dikhao.
 * Logout only when our JWT auth middleware says so — not on third-party errors.
 */
export function handleSessionExpired(response, body) {
  if (typeof window === "undefined") return false;
  if (!response) return false;
  const status = response.status;

  // Plan limit exceeded — redirect to /plan for upgrade (only on user-side dashboard)
  if (status === 403 && body?.code === "upgrade_required" && !isAdminAppPath()) {
    if (!isBillingRecoveryPath()) {
      window.location.assign("/plan");
    }
    return true;
  }

  // Overdue invoice or suspended billing — redirect to /billing to pay
  if (status === 403 && (body?.code === "payment_overdue" || body?.code === "payment_paused") && !isAdminAppPath()) {
    if (!isBillingRecoveryPath()) {
      window.location.assign("/billing");
    }
    return true;
  }

  if (!isOurDashboardAuthFailure(status, body)) return false;
  try {
    if (isAdminAppPath()) {
      removeLocalStorage(Utils.storageKeys.adminToken);
      removeLocalStorage(Utils.storageKeys.adminData);
    } else {
      removeLocalStorage(Utils.storageKeys.token);
      removeLocalStorage(Utils.storageKeys.userData);
      removeLocalStorage(Utils.storageKeys.refreshToken);
      removeLocalStorage(Utils.storageKeys.authTokenLegacy);
    }
  } catch (e) {
    /* ignore */
  }
  window.location.assign(getSessionExpiredLoginUrl());
  return true;
}

let refreshInFlight = null;

function readDashboardAccessToken() {
  return typeof window !== "undefined" ? getLocalStorage(Utils.storageKeys.token) || "" : "";
}

function mergeDashboardAuthHeaders(init = {}) {
  const isForm = typeof FormData !== "undefined" && init.body instanceof FormData;
  const token = readDashboardAccessToken();
  const out = {};
  if (!isForm) out["Content-Type"] = "application/json";
  if (token) out.Authorization = `Bearer ${token}`;
  const incoming = init.headers;
  if (incoming instanceof Headers) {
    incoming.forEach((v, k) => {
      out[k] = v;
    });
  } else if (incoming && typeof incoming === "object") {
    Object.assign(out, incoming);
  }
  if (isForm) delete out["Content-Type"];
  return out;
}

/**
 * POST `/auth/refresh` with stored refresh JWT; updates access + refresh in storage.
 */
export async function refreshAccessToken() {
  if (typeof window === "undefined") return false;
  const rt = getLocalStorage(Utils.storageKeys.refreshToken);
  if (!rt) return false;
  if (refreshInFlight) return refreshInFlight;
  const base = Utils.baseurl.replace(/\/+$/, "");
  refreshInFlight = (async () => {
    try {
      const res = await fetch(`${base}/auth/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: rt }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok || body.status !== true || !body.accessToken) {
        return false;
      }
      setLocalStorage(Utils.storageKeys.token, body.accessToken);
      if (body.refreshToken) setLocalStorage(Utils.storageKeys.refreshToken, body.refreshToken);
      return true;
    } catch {
      return false;
    } finally {
      refreshInFlight = null;
    }
  })();
  return refreshInFlight;
}

/**
 * Dashboard `fetch`: Bearer + JSON (or FormData-safe). On 401, `/auth/refresh` once then retry.
 * Not for admin APIs — use `authJsonHeaders(Utils.storageKeys.adminToken)` with plain `fetch`.
 */
export async function fetchWithAuth(url, init = {}) {
  if (typeof url === "string" && url.includes("/auth/refresh")) {
    return fetch(url, init);
  }
  const merged = mergeDashboardAuthHeaders(init);
  const first = await fetch(url, { ...init, headers: merged });
  if (first.status !== 401 || init._retryAfterRefresh) {
    return first;
  }
  let body = {};
  try {
    body = await first.clone().json();
  } catch {
    body = {};
  }
  if (!isOurDashboardAuthFailure(first.status, body)) return first;
  const ok = await refreshAccessToken();
  if (!ok) {
    handleSessionExpired(first, body);
    return first;
  }
  const merged2 = mergeDashboardAuthHeaders({ ...init, headers: init.headers });
  return fetch(url, { ...init, headers: merged2, _retryAfterRefresh: true });
}

/**
 * `fetchWithAuth` + an always-on browser-console trace (open DevTools → Console, filter by the tag):
 *   [tag] → POST <url> {body}          request sent
 *   [tag] ← 200 OK in 812ms            response (warn/error level + the server message when it failed)
 *   [tag] ✖ network error …            the request never got a response (offline, CORS, proxy cut it)
 * Returns the untouched Response, so callers behave exactly as with fetchWithAuth.
 */
export async function fetchWithAuthLogged(tag, url, init = {}) {
  const t0 = Date.now();
  let payload;
  try {
    payload = typeof init.body === "string" ? JSON.parse(init.body) : undefined;
  } catch {
    payload = undefined;
  }
  console.log(`[${tag}] → ${init.method || "GET"} ${url}`, payload ?? "");
  try {
    const res = await fetchWithAuth(url, init);
    const ms = Date.now() - t0;
    let detail = "";
    if (!res.ok) {
      detail = (await res.clone().text().catch(() => "")).slice(0, 300);
    } else if ((res.headers.get("content-type") || "").includes("json")) {
      const j = await res.clone().json().catch(() => null);
      if (j && j.status === false) detail = j.message || "status:false";
    }
    const line = `[${tag}] ← ${res.status} ${res.statusText || ""} in ${ms}ms`;
    if (res.ok && !detail) console.log(line);
    else (res.status >= 500 ? console.error : console.warn)(line, detail ? { response: detail } : "");
    return res;
  } catch (err) {
    console.error(`[${tag}] ✖ network error after ${Date.now() - t0}ms (no response)`, err);
    throw err;
  }
}

/** In-memory support fields by app_id — session cache; capped so it cannot grow without bound. */
const SUPPORT_FIELDS_CACHE_MAX_APPS = 8;
const supportFieldsCacheByAppId = new Map();
const supportFieldsInFlightByAppId = new Map();

function touchSupportFieldsCacheEntry(key, rows) {
  if (supportFieldsCacheByAppId.has(key)) supportFieldsCacheByAppId.delete(key);
  supportFieldsCacheByAppId.set(key, rows);
  while (supportFieldsCacheByAppId.size > SUPPORT_FIELDS_CACHE_MAX_APPS) {
    const oldestKey = supportFieldsCacheByAppId.keys().next().value;
    supportFieldsCacheByAppId.delete(oldestKey);
  }
}

/** Active support fields (status=1). Cached per app_id; concurrent callers share one request. */
export async function getSupportFieldsForApp(appId, opts = {}) {
  const key = String(appId || "").trim();
  if (!key) return [];

  if (!opts.force && supportFieldsCacheByAppId.has(key)) {
    const rows = supportFieldsCacheByAppId.get(key);
    touchSupportFieldsCacheEntry(key, rows);
    return rows;
  }
  if (!opts.force && supportFieldsInFlightByAppId.has(key)) {
    return supportFieldsInFlightByAppId.get(key);
  }

  const promise = (async () => {
    const res = await fetchWithAuth(`${Utils.baseurl}application/support/fields`, {
      method: "POST",
      body: JSON.stringify({
        app_id: key,
        page: 1,
        pageSize: 100,
        search: "",
        status: "1",
      }),
    });
    const json = await res.json().catch(() => ({}));
    if (handleSessionExpired(res, json)) return supportFieldsCacheByAppId.get(key) || [];
    if (!json?.status) {
      throw new Error(json?.message || "Failed to load support fields");
    }
    const rows = Array.isArray(json.data) ? json.data : [];
    touchSupportFieldsCacheEntry(key, rows);
    return rows;
  })().finally(() => {
    supportFieldsInFlightByAppId.delete(key);
  });

  supportFieldsInFlightByAppId.set(key, promise);
  return promise;
}

/** Clear cache after field create/update/delete so next read refetches. */
export function invalidateSupportFieldsCache(appId) {
  const key = String(appId || "").trim();
  if (!key) {
    supportFieldsCacheByAppId.clear();
    supportFieldsInFlightByAppId.clear();
    return;
  }
  supportFieldsCacheByAppId.delete(key);
  supportFieldsInFlightByAppId.delete(key);
}

async function postJson(url, body, signal) {
  const res = await fetchWithAuth(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    ...(signal ? { signal } : {}),
  });
  const json = await res.json().catch(() => ({}));
  if (handleSessionExpired(res, json)) return { ok: false, data: [] };
  if (!json?.status) return { ok: false, data: [] };
  return { ok: true, data: json.data || [] };
}

/** Standard ajax-list row ({id,text}) -> react-select option. */
export function mapAjaxRowToOption(row) {
  const id = String(row?.id || "").trim();
  if (!id) return null;
  return {
    value: id,
    label: String(row?.text || id).trim() || id,
    raw: row,
  };
}

/** Convert ajax-list rows to react-select options. */
export function mapAjaxRowsToOptions(rows = []) {
  return (rows || []).map(mapAjaxRowToOption).filter(Boolean);
}

/**
 * Single frontend dropdown fetcher (all dropdown types).
 * mode: "rows" | "options"
 */
// AbortSignal handed to the very next fetchAjaxListData() call (see withAjaxSignal).
let pendingAjaxSignal = null;

/**
 * Run `fn` so that the fetchAjaxListData() call it makes (synchronously) can be cancelled with
 * `signal` — lets dropdowns drop the previous search request when the user keeps typing, without
 * every caller having to forward a signal.
 */
export function withAjaxSignal(signal, fn) {
  pendingAjaxSignal = signal || null;
  try {
    return fn();
  } finally {
    pendingAjaxSignal = null;
  }
}

export async function fetchAjaxListData({
  type,
  q = "",
  id = [],
  extra = {},
  mode = "rows",
} = {}) {
  const signal = pendingAjaxSignal;
  pendingAjaxSignal = null;
  const ids = Array.isArray(id) ? id : id ? [id] : [];
  const payload = {
    type,
    q: String(q || "").trim(),
    id: ids,
    ...extra,
  };
  let result;
  try {
    result = await postJson(`${Utils.baseurl}ajax-list`, payload, signal);
  } catch (err) {
    if (err?.name === "AbortError") return []; // superseded by a newer search
    throw err;
  }
  const { ok, data } = result;
  if (!ok) return [];
  const rows = data || [];
  return mode === "options" ? mapAjaxRowsToOptions(rows) : rows;
}

/**
 * JSON + optional `Authorization: Bearer`.
 * @param {string} [storageKey] - `localStorage` key (e.g. `Utils.storageKeys.token` or `Utils.storageKeys.adminToken`)
 * @param {string|null} [explicitBearer] - if set, used instead of reading from storage (e.g. `pending2FAToken` during login 2FA)
 */
export function authJsonHeaders(storageKey = Utils.storageKeys.token, explicitBearer = null) {
  let token = "";
  if (explicitBearer != null && String(explicitBearer).trim() !== "") {
    token = String(explicitBearer).trim();
  } else if (typeof window !== "undefined") {
    token = getLocalStorage(storageKey) || "";
  }
  const h = { "Content-Type": "application/json" };
  if (token) h.Authorization = `Bearer ${token}`;
  return h;
}

/** How billing country was detected (for UI / debugging). */
export const BILLING_COUNTRY_SOURCES = Object.freeze({
  gps: { id: "gps", label: "GPS location" },
  ip: { id: "ip", label: "IP address" },
  locale: { id: "locale", label: "browser language" },
  timezone: { id: "timezone", label: "timezone" },
  default: { id: "default", label: "default region" },
  cache: { id: "cache", label: "saved region" },
});

const BILLING_COUNTRY_STORAGE_KEY = "billingCountryCode";

export function getBillingCountrySourceLabel(sourceId) {
  if (!sourceId) return null;
  const entry = BILLING_COUNTRY_SOURCES[sourceId];
  return entry?.label ?? String(sourceId);
}

/** Last resolved billing country code (from localStorage). */
export function getBillingCountryMeta() {
  const countryCode = normalizeBillingCountryCode(getLocalStorage(BILLING_COUNTRY_STORAGE_KEY));
  return { countryCode };
}

function persistBillingCountry(countryCode) {
  setLocalStorage(BILLING_COUNTRY_STORAGE_KEY, countryCode);
}

/** Dev-only: log how billing country was resolved (not shown in UI). */
function logBillingCountryDebug(countryCode, source) {
  if (process.env.NODE_ENV === "production") return;
  const label = getBillingCountrySourceLabel(source);
  console.info(
    `[billing-geo] country=${countryCode || "—"} source=${source || "—"}${label ? ` (${label})` : ""}`
  );
}

/**
 * Normalize ISO 3166-1 alpha-2 country code.
 */
function normalizeBillingCountryCode(code) {
  const cc = String(code || "").trim().toUpperCase();
  return /^[A-Z]{2}$/.test(cc) ? cc : null;
}

/** GPS → reverse geocode (BigDataCloud). */
function resolveCountryFromGps() {
  return new Promise((resolve, reject) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      reject(new Error("geolocation_unavailable"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const url =
            `https://api.bigdatacloud.net/data/reverse-geocode-client` +
            `?latitude=${encodeURIComponent(position.coords.latitude)}` +
            `&longitude=${encodeURIComponent(position.coords.longitude)}` +
            `&localityLanguage=en`;
          const response = await fetch(url);
          if (!response.ok) throw new Error("reverse_geocode_failed");
          const data = await response.json();
          const code = normalizeBillingCountryCode(data?.countryCode);
          if (!code) reject(new Error("country_not_found"));
          else resolve(code);
        } catch (err) {
          reject(err);
        }
      },
      (error) => reject(error),
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 3600000 }
    );
  });
}

/**
 * ipapi.co client IP lookup URL.
 * Free: https://ipapi.co/json/ (rate limited)
 * Paid: set REACT_APP_IPAPI_KEY — sign up at https://ipapi.co/pricing/
 * @see https://ipapi.co/api/
 */
function getIpapiClientLookupUrl() {
  const key = String(process.env.REACT_APP_IPAPI_KEY || "").trim();
  if (!key) return "https://ipapi.co/json/";
  return `https://ipapi.co/json/?key=${encodeURIComponent(key)}`;
}

/** IP geolocation via ipapi.co (no browser permission). */
async function resolveCountryFromIp() {
  const response = await fetch(getIpapiClientLookupUrl());
  if (response.status === 403) throw new Error("ipapi_auth_failed");
  if (!response.ok) throw new Error("ipapi_failed");
  const data = await response.json();
  if (data?.error) throw new Error(data.reason || "ipapi_error");
  const code = normalizeBillingCountryCode(data?.country_code || data?.country);
  if (!code) throw new Error("country_not_found");
  return code;
}

/** Browser locale (e.g. en-IN → IN). */
function resolveCountryFromLocale() {
  if (typeof navigator === "undefined") return null;
  const locales = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const loc of locales) {
    const parts = String(loc || "").split("-");
    if (parts.length >= 2) {
      const region = normalizeBillingCountryCode(parts[parts.length - 1]);
      if (region) return region;
    }
  }
  return null;
}

/** Browser IANA timezone (e.g. Asia/Kolkata) for Engage date filters + billing country guess. */
export function getBrowserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

/** IANA timezone → country (best effort for INR / GBP / USD regions). */
function resolveCountryFromTimezone() {
  try {
    const tz = getBrowserTimeZone();
    if (!tz) return null;

    const exact = {
      "Asia/Kolkata": "IN",
      "Asia/Calcutta": "IN",
      "Europe/London": "GB",
      "Europe/Belfast": "GB",
      "Europe/Dublin": "GB",
      "America/New_York": "US",
      "America/Chicago": "US",
      "America/Denver": "US",
      "America/Los_Angeles": "US",
      "America/Phoenix": "US",
      "US/Pacific": "US",
      "US/Eastern": "US",
      "US/Central": "US",
      "US/Mountain": "US",
    };
    if (exact[tz]) return exact[tz];

    if (/^Asia\/(Kolkata|Calcutta)/i.test(tz)) return "IN";
    if (/^Europe\/(London|Belfast|Guernsey|Jersey|Isle_of_Man)/i.test(tz)) return "GB";
    if (/^(America|US|Canada|Pacific|Atlantic)\//i.test(tz)) return "US";
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * Resolve billing country for `x-billing-country` header (currency on backend).
 * Fallback chain: IP → GPS → timezone → browser locale → default (USD/US).
 * Locale is last — e.g. en-GB language in India must not override IP/timezone.
 * Caches result in localStorage. `optional: true` returns `{}` only when not in a browser.
 */
export async function resolveBillingGeoHeaders({ forcePrompt = false, optional = false } = {}) {
  const headerName = "x-billing-country";
  const sourceHeaderName = "x-billing-country-source";

  const toHeaders = (cc, source) => {
    if (!cc) return {};
    const headers = { [headerName]: cc };
    if (source) headers[sourceHeaderName] = source;
    return headers;
  };

  if (typeof window === "undefined") {
    if (optional) return {};
    throw new Error("geolocation_unavailable");
  }

  if (!forcePrompt) {
    const cached = normalizeBillingCountryCode(getLocalStorage(BILLING_COUNTRY_STORAGE_KEY));
    if (cached) {
      logBillingCountryDebug(cached, "cache");
      return toHeaders(cached);
    }
  }

  const resolvers = [
    { source: "ip", fn: () => resolveCountryFromIp() },
    { source: "gps", fn: () => resolveCountryFromGps() },
    { source: "timezone", fn: () => Promise.resolve(resolveCountryFromTimezone()) },
    { source: "locale", fn: () => Promise.resolve(resolveCountryFromLocale()) },
  ];

  for (const { source, fn } of resolvers) {
    try {
      const cc = await fn();
      if (cc) {
        persistBillingCountry(cc);
        logBillingCountryDebug(cc, source);
        return toHeaders(cc, source);
      }
    } catch {
      /* try next source */
    }
  }

  const fallback =
    normalizeBillingCountryCode(DEFAULT_BILLING_CURRENCY?.country_code) || "US";
  persistBillingCountry(fallback);
  logBillingCountryDebug(fallback, "default");
  return toHeaders(fallback, "default");
}

/**
 * Bearer only (e.g. multipart). Same `storageKey` / `explicitBearer` rules as {@link authJsonHeaders}.
 */
export function authHeaders(storageKey = Utils.storageKeys.token, explicitBearer = null) {
  let token = "";
  if (explicitBearer != null && String(explicitBearer).trim() !== "") {
    token = String(explicitBearer).trim();
  } else if (typeof window !== "undefined") {
    token = getLocalStorage(storageKey) || "";
  }
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** Internal post-login path from `?redirect=` (blocks open redirects). */
export function getSafeRedirectPath(searchParams) {
  if (!searchParams) return null;
  const raw = searchParams.get("redirect") || "";
  if (!raw) return null;
  try {
    const decoded = decodeURIComponent(raw);
    if (!decoded.startsWith("/") || decoded.startsWith("//")) return null;
    if (decoded.startsWith("/signIn") || decoded.startsWith("/signup")) return null;
    return decoded;
  } catch {
    return null;
  }
}

/** Staff post-login: one owner app → app dashboard; else support ticket app or /apps list. */
export function resolveStaffPostLoginPath(userData) {
  const singleAppId = String(userData?.owner_single_app_id || "").trim();
  if (singleAppId) return `/apps/${singleAppId}`;
  const tmAppId = String(userData?.team_member_app_id || "").trim();
  if (tmAppId) return `/apps/${tmAppId}/support/ticket`;
  return "/apps";
}

export function hasCompletedOnboarding(userData) {
  return Boolean(
    userData?.onboard_first &&
    userData?.onboard_second &&
    userData?.onboard_third
  );
}

/** Where to send user after free plan is saved. */
export function getPostFreePlanPath(userData) {
  return hasCompletedOnboarding(userData) ? "/apps" : "/steps";
}

const PLAN_CHECKOUT_KEY = "planCheckoutIntent";
const PLAN_CHECKOUT_TTL_MS = 60 * 60 * 1000;

function savePlanCheckoutIntent(plan, billingCycle = "monthly") {
  if (!plan?.id) return;
  setLocalStorage(
    PLAN_CHECKOUT_KEY,
    JSON.stringify({
      plan: {
        id: plan.id,
        name: plan.name,
        plan_type: plan.plan_type,
        price: plan.price,
        price_amount: plan.price_amount,
        pricing: plan.pricing,
        currency_symbol: plan.currency_symbol,
        is_contact_sales: plan.is_contact_sales,
        period: plan.period,
      },
      billingCycle,
      ts: Date.now(),
    })
  );
}

export function getPlanCheckoutIntent() {
  const raw = getLocalStorage(PLAN_CHECKOUT_KEY);
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    if (!data?.plan?.id) return null;
    if (Date.now() - (data.ts || 0) > PLAN_CHECKOUT_TTL_MS) {
      removeLocalStorage(PLAN_CHECKOUT_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearPlanCheckoutIntent() {
  removeLocalStorage(PLAN_CHECKOUT_KEY);
}

function checkoutPathForPlanType(planType, isContactSales) {
  if (isContactSales || planType === PLAN_TYPE_CODES[2].value) return "/plan-change-request";
  if (planType === PLAN_TYPE_CODES[1].value) return "/payment";
  if (planType === PLAN_TYPE_CODES[0].value) return "/plan";
  return "/plan";
}

/** Sign-in URL that resumes checkout for the selected plan after login. */
export function getPlanCheckoutSignInPath(plan, billingCycle = "monthly") {
  savePlanCheckoutIntent(plan, billingCycle);
  const dest = checkoutPathForPlanType(Number(plan.plan_type), plan.is_contact_sales);
  return `/signIn?redirect=${encodeURIComponent(dest)}`;
}

/** After login: use stored checkout intent to pick /payment or /plan. */
export function resolvePostLoginRedirect(redirectPath) {
  const intent = getPlanCheckoutIntent();
  if (!intent) return redirectPath;
  return checkoutPathForPlanType(
    Number(intent.plan?.plan_type),
    intent.plan?.is_contact_sales
  );
}

async function saveFreePlanSelection(planId, userId, geoHeaders) {
  const response = await fetch(`${Utils.baseurl}save/plan-type`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...geoHeaders },
    body: JSON.stringify({ plan_id: planId, userId }),
  });
  return response.json();
}

/**
 * Plan / landing CTA — free → save + /steps or /apps; growth → /payment; enterprise → /plan-change-request or /signup.
 */
export async function executePlanSelection({
  plan,
  billingCycle = "monthly",
  userData,
  navigate,
  geoHeaders = {},
}) {
  if (!plan?.id) return false;

  const planType = Number(plan.plan_type);

  if (!userData?.id) {
    navigate(getPlanCheckoutSignInPath(plan, billingCycle));
    return true;
  }

  if (planType === PLAN_TYPE_CODES[0].value) {
    try {
      const result = await saveFreePlanSelection(plan.id, userData.id, geoHeaders);
      clearPlanCheckoutIntent();
      if (result.status) {
        navigate(getPostFreePlanPath(userData));
        return true;
      }
      toast.error(result.message || "Could not select plan");
    } catch (error) {
      console.error(error);
      toast.error("Could not select plan");
    }
    return false;
  }

  if (planType === PLAN_TYPE_CODES[2].value || plan.is_contact_sales) {
    clearPlanCheckoutIntent();
    if (userData?.id) {
      navigate("/plan-change-request", { state: { plan } });
    } else {
      navigate("/signup");
    }
    return true;
  }

  savePlanCheckoutIntent(plan, billingCycle);
  navigate("/payment", {
    state: {
      plan: {
        id: plan.id,
        name: plan.name,
        plan_type: plan.plan_type,
        price: plan.price,
        price_amount: plan.price_amount,
        pricing: plan.pricing,
        currency_symbol: plan.currency_symbol,
        period: plan.period || "/mo",
        billingCycle,
      },
    },
  });
  return true;
}

export function getAppOrigin() {
  return typeof window !== "undefined" ? window.location.origin : "";
}

/** Public marketing site (Next.js). Terms / privacy / docs live there. Requires REACT_APP_MARKETING_URL. */
export function getMarketingUrl(path = "") {
  const base = String(process.env.REACT_APP_MARKETING_URL || "").replace(/\/$/, "");
  if (!path) return base;
  const p = String(path).startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}

export function getViewportBoundPosition(rect, menuWidth, menuHeight, padding = 8) {
  let left = rect.left;
  let top = rect.bottom + 4;
  if (left + menuWidth > window.innerWidth - padding) left = window.innerWidth - menuWidth - padding;
  if (left < padding) left = padding;
  if (top + menuHeight > window.innerHeight - padding) top = rect.top - menuHeight + rect.height + 15;
  if (top < padding) top = padding;
  return { left, top };
}

export function getAnchoredBoundPosition(rect, menuWidth, menuHeight, boundaryRect, padding = 8, gap = 6) {
  const boundX = boundaryRect || { left: 0, right: window.innerWidth };
  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;
  const openBelow = spaceBelow >= menuHeight + gap || spaceBelow >= spaceAbove;
  let left = rect.left;
  let top = openBelow ? rect.bottom + gap : rect.top - menuHeight - gap;
  const leftMin = Math.max(padding, boundX.left + padding);
  const leftMax = Math.min(window.innerWidth - padding, boundX.right - menuWidth - padding);
  if (Number.isFinite(leftMax)) left = Math.min(left, leftMax);
  left = Math.max(left, leftMin);
  return { left, top, placement: openBelow ? "bottom" : "top" };
}

export async function copyToClipboard(text) {
  if (text == null || text === "") return;
  const value = String(text);
  try {
    await navigator.clipboard.writeText(value);
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = value;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
}

/** Shared server-side list filter payloads for subscription-style and user lists. */

/** True if any field in a plain filter object is non-empty (trimmed strings). */
export function filtersObjectHasAnyValue(f) {
  if (!f) return false;
  return Object.values(f).some((v) => String(v ?? '').trim() !== '');
}

export const EMPTY_SUBSCRIPTION_LIST_FILTERS = {
  subscription_id: '',
  notify_sphere_id: '',
  email: '',
  phone: '',
  device_model: '',
  device_type: '',
  status: '',
  name: '',
  dateFrom: '',
  dateTo: '',
  datePreset: '',
};

export const EMPTY_USERS_LIST_FILTERS = {
  notify_sphere_id: '',
  email: '',
  phone: '',
  name: '',
  dateFrom: '',
  dateTo: '',
  datePreset: '',
  tag_key: '',
  tag_value: '',
};

/** Body for POST `get/app/subscriptions` (and test subs with `isTest: 1` added in caller). */
export function buildSubscriptionListBody(f) {
  const out = {};
  if (f.subscription_id?.trim()) out.subscription_id = f.subscription_id.trim();
  if (f.notify_sphere_id?.trim()) out.notify_sphere_id = f.notify_sphere_id.trim();
  if (f.email?.trim()) out.email = f.email.trim();
  if (f.phone?.trim()) out.phone = f.phone.trim();
  if (f.device_model?.trim()) out.device_model = f.device_model.trim();
  if (f.device_type?.trim()) out.device_type = f.device_type.trim();
  if (f.name?.trim()) out.name = f.name.trim();
  if (f.status !== '' && f.status !== null && f.status !== undefined) {
    const n = Number(f.status);
    if (Number.isFinite(n) && n !== 0) out.status = n;
  }
  if (f.dateFrom?.trim() && f.dateTo?.trim()) {
    out.date_from = f.dateFrom.trim();
    out.date_to = f.dateTo.trim();
  }
  return out;
}

/** Body for POST `get/app/users`. */
export function buildUsersListBody(f) {
  const out = {};
  if (f.notify_sphere_id?.trim()) out.notify_sphere_id = f.notify_sphere_id.trim();
  if (f.email?.trim()) out.email = f.email.trim();
  if (f.phone?.trim()) out.phone = f.phone.trim();
  if (f.name?.trim()) out.name = f.name.trim();
  if (f.tag_key?.trim()) {
    out.tag_key = f.tag_key.trim();
    if (f.tag_value?.trim()) out.tag_value = f.tag_value.trim();
  }
  if (f.dateFrom?.trim() && f.dateTo?.trim()) {
    out.date_from = f.dateFrom.trim();
    out.date_to = f.dateTo.trim();
  }
  return out;
}

// --- App support ticket context (context_json display) ---

/** Built-in support field names already shown on the Create Ticket modal. */
const SUPPORT_CREATE_TICKET_BUILTIN_NAME_KEYS = new Set([
  "subject",
  "description",
  "type",
  "priority",
  "status",
  "group",
  "assignee",
]);

/** Active custom fields for panel create-ticket (excludes modal defaults). */
export function filterActiveCreateTicketCustomFields(rows) {
  return (rows || []).filter((row) => {
    if (Number(row?.status) !== 1) return false;
    const fieldId = String(row?.field_id || "").trim();
    if (!fieldId) return false;
    if (fieldId.toLowerCase().startsWith("std_")) return false;
    if (SUPPORT_CREATE_TICKET_BUILTIN_NAME_KEYS.has(normalizeSupportFieldNameKey(row?.name))) return false;
    return true;
  });
}

export function normalizeSupportFieldOptionRows(input) {
  if (!Array.isArray(input)) return [];
  return input.map((item) => {
    if (item && typeof item === "object" && !Array.isArray(item)) {
      return {
        label: String(item.label || "").trim(),
        value: String(item.value ?? item.label ?? "").trim(),
      };
    }
    const str = String(item || "").trim();
    return { label: str, value: str };
  });
}

/** Client API URL for ticket create (client API / Postman). */
export function buildClientSupportTicketCreateUrl(baseurl, appId) {
  const base = String(baseurl || "").replace(/\/?$/, "/");
  return `${base}client/${encodeURIComponent(String(appId || "").trim())}/support/ticket`;
}

function formatPostmanCustomFieldValue(raw) {
  if (raw === undefined || raw === null || raw === "") return "";
  if (typeof raw === "boolean") return raw ? "true" : "";
  return String(raw);
}

/** MIME for Postman upload metadata — from `File.type` or {@link SUPPORT_TICKET_FILE_TYPES} extension. */
function resolveSupportTicketUploadMimeType(file, filename) {
  const fromFile = String(file?.type || "").trim();
  if (fromFile) return fromFile;
  const name = String(filename || file?.name || "");
  const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
  const mimes = SUPPORT_TICKET_FILE_TYPES[ext];
  return mimes?.[0] || "";
}

/**
 * Postman-ready JSON body for client `POST /client/:appid/support/ticket`.
 * @param {object} form — panel create form (subject, message, type, priority, group_id, team_member_id, requester_*)
 * @param {Record<string, string|boolean>} customValues — keyed by field_id
 * @param {Array<{ field_id: string }>} fieldDefs — active custom field rows
 * @param {Array<{ file?: File, name?: string, file_name?: string }>} attachmentItems — panel create attachments
 */
export function buildClientSupportTicketPostmanPayload(
  form,
  customValues = {},
  fieldDefs = [],
  attachmentItems = []
) {
  const fields = [];
  for (const def of fieldDefs || []) {
    const id = String(def?.field_id || "").trim();
    if (!id) continue;
    fields.push({ id, value: formatPostmanCustomFieldValue(customValues[id]) });
  }
  const uploads = (attachmentItems || [])
    .map((item) => {
      const name = item?.file?.name || item?.name || item?.file_name;
      if (!name) return null;
      const nameStr = String(name);
      return {
        name: nameStr,
        type: resolveSupportTicketUploadMimeType(item?.file, nameStr),
      };
    })
    .filter(Boolean);
  return {
    subject: String(form?.subject || "").trim(),
    description: String(form?.message || "").trim(),
    type: form?.type || "problem",
    priority: form?.priority || "normal",
    requester: {
      name: String(form?.requester_name || "").trim(),
      email: String(form?.requester_email || "").trim(),
    },
    fields,
    assignee_id: form?.team_member_id ? String(form.team_member_id) : "",
    group_id: form?.group_id ? String(form.group_id) : "",
    comment: { uploads },
  };
}

// --- App support ticket message UI (avatars, mailbox parsing) ---

export function parseSupportMailboxAddress(raw) {
  const value = String(raw || "").trim();
  if (!value) return { name: "", email: "" };
  const wrapped = value.match(/^(.+?)\s*<([^<>]+@[^<>]+)>$/);
  if (wrapped) {
    return {
      name: wrapped[1].replace(/^["']|["']$/g, "").trim(),
      email: wrapped[2].trim().toLowerCase(),
    };
  }
  if (value.includes("@")) return { name: "", email: value.toLowerCase() };
  return { name: value, email: "" };
}

/** Absolute URL for `/uploads/...` paths (or passthrough for http/blob). */
export function partnerMediaUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || String(path).startsWith("blob:")) return path;
  const base = String(Utils.baseurl || "").replace(/\/+$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Partner logo: uploaded image, else initials + nsAvatarColor. */
export function PartnerLogo({ partner, size = 36, className = "" }) {
  if (!partner) return null;
  const palette = nsAvatarColor(partner.slug || partner.name || partner.id);
  const src = partnerMediaUrl(partner.logo_url);
  const useCssSize = className.split(/\s+/).includes("pi-logo");
  // contain + padding so wide logos (wordmarks) are not cropped
  const boxStyle = useCssSize
    ? {
        objectFit: "contain",
        objectPosition: "center",
        flexShrink: 0,
        background: "#fff",
        border: "1px solid #d1d5db",
        padding: 4,
        boxSizing: "border-box",
      }
    : {
        width: size,
        height: size,
        borderRadius: 8,
        objectFit: "contain",
        objectPosition: "center",
        flexShrink: 0,
        background: "#fff",
        border: "1px solid #d1d5db",
        padding: Math.max(4, Math.round(size * 0.08)),
        boxSizing: "border-box",
      };

  if (src) {
    return <img className={className} src={src} alt="" style={boxStyle} />;
  }

  return (
    <span
      className={className}
      style={
        useCssSize
          ? { background: palette.bg, color: palette.text, border: "1px solid #d1d5db" }
          : {
              width: size,
              height: size,
              borderRadius: 8,
              background: palette.bg,
              color: palette.text,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: size > 40 ? 15 : 12,
              flexShrink: 0,
            }
      }
      aria-hidden
    >
      {getAvatarInitials(partner.name) || "P"}
    </span>
  );
}

/** Name cell with initials avatar (lists, sidebar). */
export function NsPersonCell({ name, email }) {
  const label = String(name || "").trim() || String(email || "").trim() || "—";
  const c = nsAvatarColor(email || name);
  return (
    <div className="ns-requester">
      <span className="ns-avatar" style={{ background: c.bg, color: c.text }}>
        {getAvatarInitials(name, email)}
      </span>
      <div style={{ minWidth: 0 }}>
        <div className="ns-requester-name">{label}</div>
      </div>
    </div>
  );
}

// --- App support ticket list tabs ---

export const TICKET_LIST_TABS = [
  { key: "new", label: "New" },
  { key: "recent", label: "Recent" },
  { key: "all_open", label: "All Open" },
  { key: "closed", label: "Closed" },
];

export function normalizeTicketListTab(tabParam) {
  const key = String(tabParam || "recent").trim().toLowerCase();
  return TICKET_LIST_TABS.some((t) => t.key === key) ? key : "recent";
}

/** localStorage key for last selected Tickets list tab (New/Recent/All Open/Closed). */
export function supportTicketListTabStorageKey(appId) {
  return `ns_support_ticket_list_tab_${String(appId || "").trim()}`;
}

// --- App support open ticket tabs (localStorage) ---

/** localStorage key for open ticket detail tabs strip. */
function supportOpenTabsStorageKey(appId) {
  return `ns_support_open_tabs_${String(appId || "").trim()}`;
}

export function loadSupportOpenTabs(appId) {
  if (!appId) return [];
  try {
    const raw = getLocalStorage(supportOpenTabsStorageKey(appId));
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((t) => ({
        id: Number(t?.id),
        ticket_ref: t?.ticket_ref ? String(t.ticket_ref) : "",
        subject: t?.subject ? String(t.subject) : "",
      }))
      .filter((t) => Number.isFinite(t.id) && t.id > 0);
  } catch {
    return [];
  }
}

/** Add tab at end if new; update labels in place if already open (keeps tab order). */
export function touchSupportOpenTab(appId, conversation) {
  if (!appId || !conversation?.id) return loadSupportOpenTabs(appId);
  const id = Number(conversation.id);
  if (!Number.isFinite(id)) return loadSupportOpenTabs(appId);
  const tabs = loadSupportOpenTabs(appId);
  const entry = {
    id,
    ticket_ref: conversation.ticket_ref || `Ticket #${id}`,
    subject: conversation.subject ? String(conversation.subject).trim() : "",
  };
  const idx = tabs.findIndex((t) => t.id === id);
  const next =
    idx >= 0
      ? tabs.map((t, i) => (i === idx ? { ...t, ...entry } : t))
      : [...tabs, entry];
  setLocalStorage(supportOpenTabsStorageKey(appId), JSON.stringify(next));
  return next;
}

/** @returns remaining tabs after removal */
export function removeSupportOpenTab(appId, conversationId) {
  const id = Number(conversationId);
  const next = loadSupportOpenTabs(appId).filter((t) => t.id !== id);
  if (appId) setLocalStorage(supportOpenTabsStorageKey(appId), JSON.stringify(next));
  return next;
}

export function supportOpenTabLabelParts(tab) {
  const ref = tab?.ticket_ref || (tab?.id ? `Ticket #${tab.id}` : "Ticket");
  const subj = tab?.subject ? String(tab.subject).trim() : "";
  const subject = subj ? (subj.length > 28 ? `${subj.slice(0, 28)}…` : subj) : "";
  const title = subj ? `${subj} · ${ref}` : ref;
  return { subject, ref, title };
}

/** Pagination page-number items with ellipsis for lists. */
export function getPageItems(total, current) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const items = [];
  const add = (v) => items.push(v);
  add(1);
  if (current > 4) add("…");
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let p = start; p <= end; p += 1) add(p);
  if (current < total - 3) add("…");
  add(total);
  return items;
}

/** Default page size from Utils config (always >= 1). */
export function getDefaultPageSize() {
  return Math.max(1, Number(Utils.pagination?.defaultPageSize) || 20);
}

/** Total pages for a given total-row count and pageSize (always >= 1). */
export function getTotalPages(totalRows, pageSize) {
  return Math.max(1, Math.ceil(totalRows / (pageSize || 1)));
}

/** Estimated dropdown menu height for action menus. */
export function getEstimatedActionMenuHeight(optionCount, rowHeight = 50, verticalPadding = 5) {
  return optionCount * rowHeight + verticalPadding;
}

/** Default Engage report range start (ISO date, N days ago). */
export function defaultEngageDateFrom(days = 30) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

/** Local calendar date as YYYY-MM-DD (avoids UTC shift from toISOString). */
export function toLocalIsoDate(d = new Date()) {
  const x = d instanceof Date ? d : new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Local clock time as HH:mm (avoids UTC shift from toISOString). */
export function toLocalIsoTime(d = new Date()) {
  const x = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(x.getTime())) return "";
  return `${String(x.getHours()).padStart(2, "0")}:${String(x.getMinutes()).padStart(2, "0")}`;
}

/** YYYY-MM-DD + HH:mm → Date in the browser's local timezone. */
export function combineLocalDateTime(dateIso, timeHm) {
  if (!dateIso || !timeHm) return null;
  const [y, mo, d] = String(dateIso).split("-").map((n) => parseInt(n, 10));
  const [hh, mi] = String(timeHm).split(":").map((n) => parseInt(n, 10));
  if (!y || !mo || !d || Number.isNaN(hh) || Number.isNaN(mi)) return null;
  const dt = new Date(y, mo - 1, d, hh, mi, 0, 0);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

/** Parse YYYY-MM-DD as local noon (stable for calendar components). */
export function parseLocalIsoDate(iso) {
  if (!iso) return startOfLocalDay();
  const [y, m, d] = String(iso).split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return startOfLocalDay();
  return new Date(y, m - 1, d, 12, 0, 0, 0);
}

function startOfLocalDay(d = new Date()) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function getWeekMonday(d) {
  const x = startOfLocalDay(d);
  const dow = x.getDay();
  const diff = dow === 0 ? -6 : 1 - dow;
  x.setDate(x.getDate() + diff);
  return x;
}

/** Sunday at end of the ISO week that contains `weekMonday`. */
function getWeekSunday(weekMonday) {
  const x = startOfLocalDay(weekMonday);
  x.setDate(x.getDate() + 6);
  return x;
}

/** Last calendar day of the month containing `d`. */
function getMonthEnd(d) {
  const x = startOfLocalDay(d);
  return new Date(x.getFullYear(), x.getMonth() + 1, 0);
}

/** Start calendar year of the Indian financial year (Apr 1 – Mar 31) containing `d`. */
function getFinancialYearStartYear(d) {
  const x = startOfLocalDay(d);
  return x.getMonth() >= 3 ? x.getFullYear() : x.getFullYear() - 1;
}

/** Apr 1 – Mar 31 bounds for a financial year that begins in `startYear`. */
function getFinancialYearBounds(startYear) {
  return {
    start: new Date(startYear, 3, 1),
    end: new Date(startYear + 1, 2, 31),
  };
}

/** Format dashboard chart X-axis: day → "11 aug", month → "July 2026". */
export function formatChartAxisLabel(period, granularity = "day") {
  if (!period) return "";
  if (granularity === "month") {
    const m = String(period).trim().match(/^(\d{4})-(\d{2})/);
    if (!m) return String(period);
    const date = new Date(Number(m[1]), Number(m[2]) - 1, 1);
    const month = date.toLocaleDateString(DEFAULT_DISPLAY_LOCALE, { month: "long" });
    return `${month} ${m[1]}`;
  }
  const date = toDisplayDate(period);
  if (!date) return "";
  const day = date.getDate();
  const month = date.toLocaleDateString(DEFAULT_DISPLAY_LOCALE, { month: "short" }).toLowerCase();
  return `${day} ${month}`;
}

/** Preset list for {@link DateRangePicker} (usable outside Engage). */
export const DATE_RANGE_PRESETS = [
  { id: "last_24_hours", label: "Last 24 hours" },
  { id: "today", label: "Today" },
  { id: "yesterday", label: "Yesterday" },
  { id: "last_7_days", label: "Last 7 days" },
  { id: "last_30_days", label: "Last 30 days" },
  { id: "this_week", label: "This week" },
  { id: "last_week", label: "Last week" },
  { id: "this_month", label: "This month" },
  { id: "last_month", label: "Last month" },
  { id: "this_year", label: "This year" },
  { id: "last_year", label: "Last year" },
  { id: "this_financial_year", label: "This financial year" },
  { id: "last_financial_year", label: "Last financial year" },
  { id: "custom", label: "Custom range" },
];

/** Label for a date filter: preset name, "from – to" for a custom range, else "All time". */
export function dateRangeLabel(preset, from, to) {
  const p = preset && preset !== "custom" ? DATE_RANGE_PRESETS.find((x) => x.id === preset) : null;
  if (p) return p.label;
  if (from && to) return `${from} – ${to}`;
  return "All time";
}


/** Resolve preset id → { dateFrom, dateTo } (ISO local dates). */
export function getDateRangeForPreset(presetId) {
  const today = startOfLocalDay();
  const todayIso = toLocalIsoDate(today);

  switch (presetId) {
    case "last_24_hours": {
      const to = new Date();
      const from = new Date(to.getTime() - 24 * 60 * 60 * 1000);
      return {
        dateFrom: toLocalIsoDate(from),
        dateTo: toLocalIsoDate(to),
        preset: "last_24_hours",
      };
    }
    case "yesterday": {
      const y = new Date(today);
      y.setDate(y.getDate() - 1);
      const iso = toLocalIsoDate(y);
      return { dateFrom: iso, dateTo: iso, preset: "yesterday" };
    }
    case "this_week": {
      const start = getWeekMonday(today);
      const end = getWeekSunday(start);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "this_week",
      };
    }
    case "last_week": {
      const thisMon = getWeekMonday(today);
      const end = new Date(thisMon);
      end.setDate(end.getDate() - 1);
      const start = new Date(end);
      start.setDate(start.getDate() - 6);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "last_week",
      };
    }
    case "this_month": {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      const end = getMonthEnd(today);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "this_month",
      };
    }
    case "last_month": {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth(), 0);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "last_month",
      };
    }
    case "this_year": {
      const year = today.getFullYear();
      const start = new Date(year, 0, 1);
      const end = new Date(year, 11, 31);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "this_year",
      };
    }
    case "last_year": {
      const year = today.getFullYear() - 1;
      const start = new Date(year, 0, 1);
      const end = new Date(year, 11, 31);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "last_year",
      };
    }
    case "this_financial_year": {
      const { start, end } = getFinancialYearBounds(getFinancialYearStartYear(today));
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "this_financial_year",
      };
    }
    case "last_financial_year": {
      const { start, end } = getFinancialYearBounds(getFinancialYearStartYear(today) - 1);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: toLocalIsoDate(end),
        preset: "last_financial_year",
      };
    }
    case "last_7_days": {
      const start = new Date(today);
      start.setDate(start.getDate() - 6);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: todayIso,
        preset: "last_7_days",
      };
    }
    case "last_30_days": {
      const start = new Date(today);
      start.setDate(start.getDate() - 30);
      return {
        dateFrom: toLocalIsoDate(start),
        dateTo: todayIso,
        preset: "last_30_days",
      };
    }
    case "custom":
      return { dateFrom: todayIso, dateTo: todayIso, preset: "custom" };
    case "today":
    default:
      return { dateFrom: todayIso, dateTo: todayIso, preset: "today" };
  }
}

/** First match wins when several presets share the same dates (e.g. Today = start of month on the 1st). */
const DATE_RANGE_PRESET_DETECT_ORDER = [
  "today",
  "yesterday",
  "last_7_days",
  "last_30_days",
  "this_week",
  "last_week",
  "this_month",
  "last_month",
  "this_financial_year",
  "last_financial_year",
  "this_year",
  "last_year",
];

/** Match URL/manual range to a preset when possible. */
export function detectDateRangePreset(dateFrom, dateTo) {
  if (!dateFrom || !dateTo) return "today";
  for (const id of DATE_RANGE_PRESET_DETECT_ORDER) {
    const r = getDateRangeForPreset(id);
    if (r.dateFrom === dateFrom && r.dateTo === dateTo) return id;
  }
  return "custom";
}

/**
 * Date-range label for pickers and filters. Always shows start – end (even when equal).
 * @param {{ part?: 'date'|'time'|'datetime', rangeSeparator?: string }} [options]
 */
export function formatDateRangeLabel(dateFrom, dateTo, options = {}) {
  if (!dateFrom || !dateTo) return "Select dates";
  const { part = "date", rangeSeparator = " – ", ...fmtOptions } = options;
  const formatPart =
    part === "time" ? formatTime : part === "datetime" ? formatDateTime : formatDate;
  const from = formatPart(dateFrom, fmtOptions);
  const to = formatPart(dateTo, fmtOptions);
  if (!from || !to) return "Select dates";
  return `${from}${rangeSeparator}${to}`;
}

function buildEngageDateQuery({ dateFrom, dateTo } = {}) {
  const qs = new URLSearchParams();
  if (dateFrom) qs.set("from", dateFrom);
  if (dateTo) qs.set("to", dateTo);
  const s = qs.toString();
  return s ? `?${s}` : "";
}

export function getEngageCampaignListPath(appRouteId, { dateFrom, dateTo } = {}) {
  return `/apps/${appRouteId}/engage/campaign${buildEngageDateQuery({ dateFrom, dateTo })}`;
}

export function getEngageOneLinkListPath(appRouteId, listSearch = "") {
  const q = listSearch ? (String(listSearch).startsWith("?") ? listSearch : `?${listSearch}`) : "";
  return `/apps/${appRouteId}/engage/onelink${q}`;
}

/** Resolve application `app_id` (UUID) from dashboard route id. */
export async function fetchApplicationAppId(routeAppId) {
  if (!routeAppId) return null;
  const s = String(routeAppId).trim();
  if (!s) return null;
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s)) return s;
  const res = await fetchWithAuth(`${Utils.baseurl}getbyid/application`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: s }),
  });
  const json = await res.json();
  return json?.data?.app_id || null;
}

/**
 * Build campaign detail URL + router state so Back returns to the previous list page.
 * `returnTo` is optional when `backSource` is `campaign` or `onelink` (computed from dates / list search).
 */
export function buildCampaignDetailNavigation(
  appRouteId,
  campaignId,
  { backSource, returnTo, dateFrom, dateTo, listSearch } = {}
) {
  const qs = new URLSearchParams();
  if (dateFrom) qs.set("from", dateFrom);
  if (dateTo) qs.set("to", dateTo);
  if (backSource) qs.set("back", backSource);

  const path = `/apps/${appRouteId}/engage/campaign/${campaignId}${qs.toString() ? `?${qs}` : ""}`;

  let resolvedReturnTo = returnTo;
  if (!resolvedReturnTo && backSource === "campaign") {
    resolvedReturnTo = getEngageCampaignListPath(appRouteId, { dateFrom, dateTo });
  } else if (!resolvedReturnTo && backSource === "onelink") {
    resolvedReturnTo = getEngageOneLinkListPath(appRouteId, listSearch);
  } else if (!resolvedReturnTo) {
    resolvedReturnTo = getEngageCampaignListPath(appRouteId);
  }

  return {
    path,
    state: { returnTo: resolvedReturnTo },
  };
}

export function resolveCampaignDetailBackPath({
  routeAppId,
  locationState,
  searchParams,
  dateFrom,
  dateTo,
}) {
  if (locationState?.returnTo) {
    return locationState.returnTo;
  }

  if (searchParams.get("back") === "onelink" && routeAppId) {
    return getEngageOneLinkListPath(routeAppId);
  }

  return getEngageCampaignListPath(routeAppId, { dateFrom, dateTo });
}

/** Shared react-select theme styles used across all dropdowns. */
export const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: state.isFocused ? "rgb(67, 70, 206)" : "#ced4da",
    boxShadow: state.isFocused ? "0 0 0 1px rgb(67, 70, 206)" : "none",
    "&:hover": { borderColor: state.isFocused ? "rgb(67, 70, 206)" : "#adb5bd" },
  }),
  valueContainer: (base) => ({
    ...base,
    paddingLeft: 12,
    gap: 6,
  }),
  placeholder: (base) => ({
    ...base,
    marginLeft: 0,
  }),
  menu: (base) => ({ ...base, zIndex: 10001 }),
  menuPortal: (base) => ({ ...base, zIndex: 10001 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "rgb(67, 70, 206)" : state.isFocused ? "rgba(67, 70, 206, 0.08)" : "white",
    color: state.isSelected ? "#fff" : "#212529",
  }),
};

// WhatsApp template HEADER format helpers - shared by WhatsAppSettings.js (create/bulk-send),
// WhatsAppPlatform.js (compose/send) and automations/AutomationBuilder.js (WhatsApp automation step).
// Template approval only locks in the header *format*; WhatsApp still requires the actual
// media (uploaded file id, public HTTPS URL, or lat/lng for LOCATION) on every single send.
export function templateHeaderFormat(row) {
  const comps = row && Array.isArray(row.components) ? row.components : [];
  const h = comps.find((c) => String(c.type || "").toUpperCase() === "HEADER");
  return String(h && h.format ? h.format : "").toUpperCase();
}

export function isFileHeaderFormat(format) {
  return format === "IMAGE" || format === "VIDEO" || format === "DOCUMENT";
}

export function headerFileAccept(format) {
  if (format === "VIDEO") return "video/mp4,video/3gpp,.mp4,.3gp";
  if (format === "DOCUMENT") return "application/pdf,.pdf";
  return "image/jpeg,image/png,.jpg,.jpeg,.png";
}
